import { useEffect, useState } from 'react';

import { setShowResult } from '../../app/applicationStatusSlice';
import { useAppSelector, useImpState } from '../../app/hooks';
import { OTPFLOW, setOtpFlow } from '../../app/otpScreenSlice';
import { SCREEN, setScreen } from '../../app/screenStateSlice';
import { clearHomePageState } from '../../utils/functionUtils';
import { merchantInfoByProductUUID } from '../../utils/productUUIDConstants';
import { PAGE } from '../../utils/routeConstant';
import { ValidationResponse } from '../../utils/validateUtils';
import Modal from '../modal/Modal';

export default function AppStatus() {
  const { language, merchantData, appStatus, dispatch, navigate } =
    useImpState();
  const [_showStatusCheckResult, setShowStatusCheckResult] = useState(
    appStatus.showResult
  );
  const [birthDay, _setBirthDay] = useState('');
  const [phoneNumber, _setPhoneNumber] = useState('');
  const [fullSSN, _setFullSSN] = useState('');
  const [_disabledBtn, setDisabledBtn] = useState(true);
  const [_birthDayErr, _setBirthDayErr] = useState(true);
  const [_phoneNumberErr, _setPhoneNumberErr] = useState(true);
  const [_SSNErr, _setSSNErr] = useState(true);
  const [matches, setMatches] = useState(
    window.matchMedia('(min-width: 768px)').matches
  );

  const validator: any = useAppSelector((state) => state.validatorSelector);

  useEffect(() => {
    window
      .matchMedia('(min-width: 768px)')
      .addEventListener('change', (e) => setMatches(e.matches));
  }, []);

  useEffect(() => {
    setDisabledBtn(true);
    if (
      validator.birthDateError === ValidationResponse.valid &&
      validator.phoneNumberError === ValidationResponse.valid &&
      validator.fullSSNError === ValidationResponse.valid &&
      birthDay !== '' &&
      phoneNumber !== '' &&
      fullSSN !== ''
    ) {
      setDisabledBtn(false);
    }
  }, [validator, birthDay, fullSSN, phoneNumber]);

  function backClick() {
    dispatch(setScreen(SCREEN.APPLICATION));
    dispatch(setOtpFlow(OTPFLOW.APPLICATION));
    setShowStatusCheckResult(false);
    dispatch(setShowResult(false));
    navigate(PAGE.HOME);
  }

  useEffect(() => {
    window.history.pushState(
      'fake-route',
      document.title,
      window.location.href
    );
    addEventListener('popstate', backClick);
    return () => {
      removeEventListener('popstate', backClick);
      if (window.history.state === 'fake-route') {
        window.history.back();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //! this function seems like it might be important, commenting out for now to keep linter happy
  // const handleContinueClick = () => {
  //   // TODO: Make an API call to pull application status
  //   dispatch(setAppStatus(''));
  //   dispatch(setScreen(SCREEN.OTPSCREEN));
  //   dispatch(setOtpFlow(OTPFLOW.STATUS));
  //   const date = new Date(birthDay);
  //   dispatch(
  //     setConsumerProfile({
  //       ...consumerProfile,
  //       dob: {
  //         year: date.getFullYear(),
  //         month: date.getMonth() + 1,
  //         day: date.getDate(),
  //       },
  //       phone: phoneNumber
  //         .split('')
  //         .filter((val) => !isNaN(+val) && val != ' ')
  //         .join(''),
  //       ssn9: fullSSN.trim().replace(/[^\d]/g, ''),
  //     })
  //   );
  //   navigate(PAGE.OTP);
  // };

  function loadDeeplink() {
    window.open(merchantData.deeplink);
  }

  return (
    <Modal
      header={language.checkStatusInMobileHeader}
      body1={language.checkStatusInMobileBody}
      qrMessage={language.qrDownload.replace(
        '$link$',
        merchantInfoByProductUUID[merchantData.productUUID].displaySignupLink
      )}
      buttonName1={language.downloadBtn}
      button1Click={loadDeeplink}
      hideMobileBtn1
      showQR
      qr={merchantData.checkApplicationQR}
      pillBtn1={!matches}
      buttonName2={language.goBackBtn}
      pillBtn2={matches}
      button2Click={() => {
        clearHomePageState(dispatch);
        navigate(PAGE.HOME);
      }}
    />
  );
}
